import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PatientSessionDataComponent } from '../../medical-recored/patient-session-data/patient-session-data.component';
import { ResourceFreeDate } from '../../orders/appointment-booking/appointment-booking.interface';
import { getNgBsObj, OutpatientParms, SharedDateService, UserSessionService } from '../../shared';
import { CallData, MsgTemplate, TotalData } from '../../call-center/call-center-reservation';
import { ToastService } from '../toast';
import { OutPatReservationService } from '../../outpatient/out-pat-appointment/out-pat-reservation/out-pat-reservation.service';
import { SmsService } from '../../promotions/SmsService/Sms.service';
import { IPromotionsMsgLog } from '../../promotions/promotions';
import { SimpleCallCenterPatientReservationComponent } from '../../call-center/simple-call-center-patient-reservation/simple-call-center-patient-reservation/simple-call-center-patient-reservation.component';
import { TranslateService } from '@ngx-translate/core';
import { SelectizeComponent } from '../selectize';
import { CancelServiceComponent } from '../../pricing/cancel-service/cancel-service.component';
import { ReservationCallModifyAppointmentComponent } from '../../call-center/reservation-call/reservation-call-modify-appointment/reservation-call-modify-appointment.component';

@Component({
  selector: 'app-doctor-reservation',
  templateUrl: './doctor-reservation.component.html',
  styleUrls: ['./doctor-reservation.component.css']
})
export class DoctorReservationComponent implements OnInit {
  monthlyOrDaily: number;
  monthNo: number;
  year: number;
  periodType: number;
  showPatient: boolean = false;
  patCode: number;
  phoneNumber: number;
  @ViewChild('popup') popup: any;
  dynamicComponent: any;
  selectedDay: UntypedFormControl = new UntypedFormControl();
  callData: CallData = <CallData>{};
  @Input() patientRservedByDoctorInCallCenter: number;
  @Output() dbC_SelectedSlot: EventEmitter<any> = new EventEmitter<any>();
  docIdFromMatrix: number;
  specialityFromMatrix: number;
  @ViewChild('specialitySearchFromMatrix') specialitySearchFromMatrix: SelectizeComponent;
  @ViewChild('doctorSearchFromMatrix') doctorSearchFromMatrix: SelectizeComponent;
  @ViewChild('specialitySearch') specialitySearch: SelectizeComponent;
  @ViewChild('doctorSearch') doctorSearch: SelectizeComponent;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  callCenterSettingsParms: any = {};
  callCenterModuleSettings: any = {};
  simpleReservationFromCallCenter: number;
  prevDateReservationFromMonthlyMatrix: number;
  docIdArr: string = '';
  mobile: any;
  sendMessageFlag: number = 1;
  callDataSerial: number;
  //data of sms message
  msgTemplateData: any
  messagesLog: IPromotionsMsgLog = <IPromotionsMsgLog>{};
  matrixPatientParams: CallData = <CallData>{};

  templateMsg: string = '';
  msgTemplate: MsgTemplate = <MsgTemplate>{};
  DoctorCode: number;
  //nursing
  docId: number;
  speciality: number;
  ShiftId: number;
  todayDate: Date;
  todayDay: number;
  todayMonth: number;
  date: Date = new Date();

  constructor(private _sharedDateService: SharedDateService,
    private _USS: UserSessionService,
    private _SmsService: SmsService,
    private _callCenterReservationService: OutPatReservationService,
    public translate: TranslateService,
    private _toaster: ToastService
  ) { }

  getToday_Date_Day_Month() {
    this.todayDate = new Date();
    this.todayDay = this.todayDate.getDate();
    this.todayMonth = this.todayDate.getMonth() + 1;
  }
  ngOnInit() {
    this.getModuleSettings();
    this.getToday_Date_Day_Month();
    this.setPatientBookedByCall();
    this.getDataFromDoctorReservationComponentModal$();
    this.firstInit();
    this.observeModal$();
    //this.getReservationParms$();
    this.date = this._sharedDateService.convertFromDateToNgBsObject(this.date);
  }


  getDataFromDoctorReservationComponentModal$() {
    if (this._USS.getModalKey('DoctorReservationComponent')) {
      console.log('this._USS.getModalKey(DoctorReservationComponent)', this._USS.getModalKey('DoctorReservationComponent'))
      this.DoctorCode = this._USS.getModalKey('DoctorReservationComponent')['inputs']['resourceId'];
      this.docId = this._USS.getModalKey('DoctorReservationComponent')['inputs']['resourceId'];
      this.patCode = this._USS.getModalKey('DoctorReservationComponent')['inputs']['patCode'];
      this.docIdArr = this._USS.getModalKey('DoctorReservationComponent')['inputs']['docIdArr'];
      this.mobile = this._USS.getModalKey('DoctorReservationComponent')['inputs']['docIdArr'];
      this.patientRservedByDoctorInCallCenter = this._USS.getModalKey('DoctorReservationComponent')['inputs']['patientRservedByDoctorInCallCenter']

      if (this.patCode > 0) {
        this.patientClicked({ 'AutoEmited': false, 'code': this.patCode, 'mobile': this.mobile }, 1)
      }
    }
  }
  getReservationParms$() {
    this._USS
      .subscribeToKey$("openDoctorMonthDates")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.patCode = keys.value.patCode
          this.mobile = keys.value.mobile;
          this.patientRservedByDoctorInCallCenter = keys.value.patientRservedByDoctorInCallCenter
          this.DoctorCode = keys.value.resourceId;
          this.docId = keys.value.resourceId;
          this.docIdArr = keys.value.docIdArr;
          if (this.patCode > 0) {
            this.patientClicked({ 'AutoEmited': false, 'code': this.patCode, 'mobile': this.mobile }, 1)
          }
        }
      });
  }
  showPatBookArea: number = 0;
  patientBookedByCall() {
    this.showPatBookArea = 1;
  }
  cancelPatientBookedByCall() {
    this.showPatBookArea = 0;

  }

  setPatientBookedByCall() {
    ////////booking callcenter//////20-5-2023/////////////
    this.callData.serial = -1;
    this.callData.callResult = '1'
    this.callData.callReason = 3;
    this.callData.reservationDate = null
    this.callData.expectedStartTime = null
    this.callData.expectedEndTime = null
    this.callData.minutesPerSlot = null;
    this.callData.callTypeFalg = 1;
    //this.callData.specialization = 4;
    this.callData.callSort = 1;
    this.callData.entityType = 3;
    this.callData.clinicCode = 0;
    this.callData.reservationType = 2;
    this.callData.callmethod = 1;
    this.callData.dataStatus = 1;
    //  1 = callcenter  2 = doctor 3 = clinic manager
    this.callData.bookedByFlag = this.patientRservedByDoctorInCallCenter;
    //////////////////////////////////////////////////
  }
  getResourceFreeDate() {
    let dailyDateObj: any = {};
    dailyDateObj = this._USS.getSessionKey('resourceFreeDate');
    if (dailyDateObj) {
      console.log("From Daily Matrix", dailyDateObj);
      this.callData.reservationDate = dailyDateObj.expectedStartTime;
      this.callData.expectedStartTime = dailyDateObj.expectedStartTime;
      this.callData.expectedEndTime = dailyDateObj.endTimeSlot;
    }
  }
  savePatientBookedByCall() {
    let patientdata: TotalData = <TotalData>{};
    if (this.monthlyOrDaily == 1) {
      this.getResourceFreeDate();
    }
    if (!this.callData.expectedStartTime || !this.callData.expectedEndTime) {
      this._toaster.activateMsg("Choose Booking Time ")
    }
    else {
      console.log("Call info = ", this.callData)
      patientdata.callData = this.callData;
      this._callCenterReservationService.addCallerData(patientdata)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(c => {

          //reservation&reservationDone&clinic
          this.callDataSerial = c.data[0].serial
          if (this.callDataSerial > 0) {
            this.saveMessagesLog();
            this.onInquery();
            this.monthlyDoctoroutPatient(this.monthNo - 1);
            this.currentFreeDate = {};
            this.firstSlotClickedTime = null;
          }
        },
          err => console.log(err),
          () => {
          });
    }
  }

  saveMessagesLog() {
    this.getMsgTemplate();
    //get template message
    if (this.msgTemplateData) {
      if (this.msgTemplateData.smsTemplate) {
        //create message
        this.replacrDatainSms()
        this.messagesLog.serial = -1
        this.messagesLog.patCode = this.patCode
        this.messagesLog.message = this.msgTemplateData.smsTemplate
        this.messagesLog.sentDate = new Date()
        this.messagesLog.sender = +JSON.parse(sessionStorage.getItem('currentUser')).userID
        this.messagesLog.mobile = +this.callData.phoneNumber;
        this.messagesLog.callDataSerial = this.callDataSerial
        this.messagesLog.messageType = 3 //رساله تاكيد حجز مريض
        this._SmsService.RemindingBookingMsg([this.messagesLog])
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(res => { }
          )
      }
    }
  }

  getMsgTemplate() {
    this.msgTemplate.fieldName = 'reservationPatientSMS'
    this.msgTemplate.reservationDate = this.callData.reservationDate;
    this.msgTemplate.specialityId = this.callData.specialization;
    this.msgTemplate.empId = this.callData.docId;
    this._SmsService.getMsgTemplate(this.msgTemplate)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res && res.data) {
            this.msgTemplateData = res.data[0];
            this.templateMsg = this.msgTemplateData.smsTemplate
          }
        }
      )
  }
  doctorName: string;
  shortDoctorName: string;
  replacrDatainSms() {
    //let SmsData:any
    let SmsData = <any>{
      reservationDate: this.callData.reservationDate,
      doctorName: this.doctorName,
      shortDoctorName: this.shortDoctorName
    };
    this.msgTemplateData.smsTemplate = this._SmsService.replaceSmSMsgData(SmsData, this.templateMsg)
    console.log(this.msgTemplateData.smsTemplate)
  }
  ShiftSelect(ev: any) {
    if (ev) {
      this.ShiftId = +ev.target.value
    }
  }
  resetData() {
    this.firstSlotClickedTime = null;
    this.currentFreeDate = <ResourceFreeDate>{};
    this.callData = <CallData>{};
    this.rightClickedSlot = null;
  }
  monthlyDoctoroutPatient(month: any) {
    //  let requestDate = this._sharedDateService.convertFromNgBsToDate(this.selectedDay.value);
    this.resetData();
    let requestDate
    if (this.periodType == 1) {
      requestDate = this._sharedDateService.convertFromNgBsToDate(this.date || new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()));
    } else {
      requestDate = new Date(this.year, month, 1)
      this.date = this._sharedDateService.convertFromNgBsToDate(new Date());
    }
    let outpatientParms: any = {}
    let date = new Date();
    outpatientParms.ReservationDate = (requestDate == undefined) ? getNgBsObj(date) : requestDate;
    outpatientParms.entityType = 3;
    outpatientParms.ResourceType = 100;
    outpatientParms.resourceId = this.docId;
    outpatientParms.patCode = this.patCode;
    outpatientParms.phoneNumber = this.phoneNumber;
    outpatientParms.periodType = this.periodType;
    outpatientParms.ShiftId = this.ShiftId;
    outpatientParms.specialityId = this.speciality;
    //nursing
    if (this.docId > 0) {
      this.DoctorCode = null
    }
    if (isNaN(outpatientParms.ReservationDate.getTime())) {
      console.log('Invalid date!');
      outpatientParms.ReservationDate = new Date();
    }
    this._USS.setSessionKey('_outpatientParms' + 6, outpatientParms);
  }
  dailyOrMonthClick(e: any) {
    if (e && !e['AutoEmited'] && e['code']) {
      if (e['code'] == 1 || e['code'] == 2 || e['code'] == 3) {
        this.showMonthlyMatirx = 1;
        this.periodType =  e['code']
        // this.onInquery()
        this.monthlyDoctoroutPatient(this.monthNo - 1);

      }
      // else if (e['code'] == 3 || e['code'] == 2) {
      //   if (e['code'] == 3) {
      //     this.showMonthlyMatirx = 1;
      //     this.periodType = 3
      //   }
      //   if (e['code'] == 2) {
      //     this.showMonthlyMatirx = 1;
      //     this.periodType = 2
      //   }
      // }
      this.callData.reservationDate = null
      this.callData.expectedStartTime = null
      this.callData.expectedStartTime = null
    }
  }
  refreshData(monthlyOrDaily:any){
    if (monthlyOrDaily == 1 || monthlyOrDaily == 2 || monthlyOrDaily == 3) {
      this.showMonthlyMatirx = 1;
      this.periodType = monthlyOrDaily
      this.monthlyDoctoroutPatient(this.monthNo - 1);

    }
    this.callData.reservationDate = null
    this.callData.expectedStartTime = null
    this.callData.expectedStartTime = null
  }
  showMonthlyMatirx: number = 0;
  monthNoClicked: number = 0;

  monthNoClick(e: any) {
    //!e['AutoEmited']
    if (e && e['code']) {
      this.showMonthlyMatirx = 1;
      this.monthlyDoctoroutPatient(e.code - 1);
      this.monthNoClicked = e.code - 1;
    }
  }


  showBookingAndCancelButton: number = 0;
  patientClicked(e: any, type: number) {
    if (e && !e['AutoEmited']) {
      if (e['code']) {
        if (type == 1) {
          this.patCode = e.code;
          this.showPatient = true;
        }
        if (type == 2) {
          this.patCode = e.code;
          this.showPatient = true;
        }
       
      }
      if (type == 3) {
        this.phoneNumber = e;
        this.showPatient = true;
      }
      this.callData.patCode = this.patCode
      this.callData.docId = this.docId
      this.callData.phoneNumber = e.mobile
      this.monthlyDoctoroutPatient(this.monthNo - 1);
      this.showBookingAndCancelButton = 1;
    }
    if (!e) {
      this.showBookingAndCancelButton = 0;
      this.showPatBookArea = 0;
    }
  }

  firstInit() {
    let date = new Date();
    this.monthNo = (date.getMonth() + 1);
    this.year = (date.getFullYear())
    let day = this._sharedDateService.day$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(day => {
        this.selectedDay.setValue(this._sharedDateService.convertFromDateToNgBsObject(day));

      }, null, () => { day.unsubscribe() })

    this.selectedDay.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(day => {
      let Date = this._sharedDateService.convertFromNgBsToDate(this.selectedDay.value);
      this._USS.setSessionKey('day', day);

      if (isNaN(Date.getTime())) {
        console.log('Invalid date!');
        Date = new Date();
      }
      this._USS.updateSessionKey('_outpatientParms', { 'ReservationDate': Date }, false);
    });
    if (this.patCode != undefined) {
      this.showPatient = true;
    }

  }

  observeModal$() {
    this._USS.getModalKey$()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.name == 'DoctorReservationComponent' && keys.inputs) {
          // الدكتور هيحجز المريض فى مركز الاتصالات  medical-side-bar patientRservedByDoctorInCallCenter = 2
          // الكول سنتر اللى هيحجز مش الدكتور patientRservedByDoctorInCallCenter = 1
          this.patCode = keys.inputs.patCode
          this.DoctorCode = keys.inputs.resourceId;
          this.docId = keys.inputs.resourceId;
          this.docIdArr = keys.inputs.docIdArr;
          this.mobile = keys.inputs.mobile;
          this.patientRservedByDoctorInCallCenter = keys.inputs.patientRservedByDoctorInCallCenter
          if (this.patCode > 0) {
            this.patientClicked({ 'AutoEmited': false, 'code': this.patCode, 'mobile': this.mobile }, 1)
          }
        }
      });
  }
  onInquery() {
    this._USS.setSessionKey('INQUERY_DATA', { docId: this.docId, patCode: this.patCode });
  }


  //___________sayed _________________________
  currentFreeDate: ResourceFreeDate = <ResourceFreeDate>{};
  /****************************************
    * call after user select slot for service
    * @param selectedSlot
    */
  firstSlotClickedTime: any;

  selectedCurrentSlot(selectedSlot: any) {
    if (selectedSlot) {



      let selectdTime = new Date(selectedSlot.startTimeSlot)
      const selectdDay = selectdTime.getDate();
      if (selectdDay < this.todayDay && this.todayMonth >= this.monthNo && this.prevDateReservationFromMonthlyMatrix != 1) {
        console.log('The next date is earlier than the current date.');
        this._toaster.activateMsg("The  date less than  today date.");
        this._USS.setSessionKey('MonthlyresourceFreeDate', null);
        this._USS.setSessionKey('Monthlyslot', null);
        selectedSlot.slotToggle = 0;
        selectedSlot.servStatus = 0;
        return
      }
      //this.time = selectedSlot.startTimeSlot;
      if (!this.firstSlotClickedTime) {
        this.firstSlotClickedTime = selectedSlot.startTimeSlot;
      }

      this.currentFreeDate.startTimeOnly = selectedSlot.startTime
      this.currentFreeDate.expectedStartTime = this.firstSlotClickedTime
      this.currentFreeDate.expectedEndTime = selectedSlot.endTimeSlot;
      this.callData.reservationDate = this.firstSlotClickedTime
      this.callData.expectedStartTime = this.firstSlotClickedTime
      this.callData.expectedEndTime = selectedSlot.endTimeSlot;
      this.callData.minutesPerSlot = selectedSlot.minutesPerSlot;
      this.currentFreeDate.minutesPerSlot = selectedSlot.minutesPerSlot
      this._USS.setSessionKey('MonthlyresourceFreeDate', this.currentFreeDate);
      this._USS.setSessionKey('Monthlyslot', selectedSlot);
      //this.getMsgTemplate();
    } else {
      //  this.time = null;

    }

  }
  unSelectedCurrentSlot(selectedSlot: any) {
    this.firstSlotClickedTime = null;
  }
  selectedDBC_CurrentSlot(selectedSlot: any) {
    if (selectedSlot) {
      this.currentFreeDate.startTimeOnly = selectedSlot.startTime
      this.currentFreeDate.expectedStartTime = selectedSlot.startTimeSlot
      this.currentFreeDate.expectedEndTime = selectedSlot.endTimeSlot
      this.currentFreeDate.minutesPerSlot = selectedSlot.minutesPerSlot
      selectedSlot.speciality = this.speciality;
      selectedSlot.patCode = this.patCode;
      this.callData.minutesPerSlot = selectedSlot.minutesPerSlot;
      if (this.simpleReservationFromCallCenter == 1) { //Simple Patient Reservation 13/12/2023 #Azmio
        selectedSlot['reservationFrom'] = 2;
        selectedSlot.startTimeSlot = this.firstSlotClickedTime ? this.firstSlotClickedTime : selectedSlot.startTimeSlot;
        selectedSlot['shortDoctorName'] = this.shortDoctorName;
        selectedSlot['doctorName'] = this.doctorName;
        this._USS.setSessionKey('MatrixSessionData', selectedSlot)
        this.dynamicComponent = SimpleCallCenterPatientReservationComponent;
        this.popup.openModal("SimpleCallCenterPatientReservationComponent", "masterParms", {}, 'lg');
      }
      else {
        this.dbC_SelectedSlot.emit(selectedSlot);
      }

      // this._USS.setSessionKey('MonthlyresourceFreeDate', this.currentFreeDate);
      // this._USS.setSessionKey('Monthlyslot', selectedSlot);
      //this.getMsgTemplate();
    } else {
      //  this.time = null;

    }

  }
  //------Open Modal Of Reserved Slot-------//
  selectedReservedCurrentSlot(selectedSlot: any) {
    this._USS.setSessionKey('MatrixSessionData', selectedSlot)
    this.dynamicComponent = PatientSessionDataComponent;
    this.popup.openModal("PatientSessionDataComponent", "masterParms", {}, 'lg');

  }
  rightClickedSlot: any;
  emitOnSlotRightActionClick(selectedSlot: any) {
    this.rightClickedSlot = selectedSlot;
    if (this.rightClickedSlot.appCode == 7148) {
      this.updateDoctor();
    }
    else if (this.rightClickedSlot.appCode == 6811) {
      this.cancelReservation();

    }
    else if (this.rightClickedSlot.appCode == 2184) {
      this.selectedReservedCurrentSlot(this.rightClickedSlot);
    }

    else if (this.rightClickedSlot.appCode == 6958) {
      //Modify Reservation Time
      this.modifyReservationTime();
    }
  }

  modifyReservationTime() {
    this.rightClickedSlot['docId'] = this.rightClickedSlot.resourceId;
    this.rightClickedSlot['serial'] = this.rightClickedSlot.ccCallSerial;
    this.dynamicComponent = ReservationCallModifyAppointmentComponent;
    this.popup.openModal("ReservationCallModifyAppointmentComponent", "Reservations", this.rightClickedSlot);

  }
  updateDoctor() {
    if (this.rightClickedSlot.ccCallSerial) {
      var modal = document.getElementById("rightClickedSlot");
      modal.style.display = 'block';
      this.specialitySearchFromMatrixClicked({ 'AutoEmited': false, 'code': this.specialityFromMatrix });
      // modal.style.width = '500px';
      // modal.style.height = '500px';
    }
    else {
      this._toaster.activateMsg('تحديث مركز الاتصالات فقط')
    }
  }

  cancelReservation() {
    if (this.rightClickedSlot.ccCallSerial) {
      this.rightClickedSlot.sendMessageFlag = true
      this.rightClickedSlot.type = 10;
      this.rightClickedSlot.serial = this.rightClickedSlot.ccCallSerial;
      //}//الالغاء حجززات مركز الاتصالت
      this.dynamicComponent = CancelServiceComponent;
      this.popup.openModal("CancelServiceComponent", "Reservations", this.rightClickedSlot);
    }
    else {
      this._toaster.activateMsg('الغاء مركز الاتصالات فقط')
    }

  }
  closeRightClickedSlot(): void {
    var modal = document.getElementById("rightClickedSlot");
    modal.style.display = 'none';
    this.monthlyDoctoroutPatient(this.monthNoClicked);
  }
  specialitySearchFromMatrixClicked(item: any) {
    this.docIdFromMatrix = null
    if (item && !item['AutoEmited'] && item['code']) {
      this.doctorSearchFromMatrix.setFastSearchKey('SpecialityId', item.code);
      this.doctorSearchFromMatrix.setFastSearchKey('ReservationDate', this.rightClickedSlot.schTime);
      this.doctorSearchFromMatrix.clear();
      this.doctorSearchFromMatrix.clearItems();
    }
  }
  specialitySearchClicked(item: any) {
    if (item && !item['AutoEmited'] && item['code']) {
      this.doctorSearch.setFastSearchKey('SpecialityId', item.code);
      this.doctorSearch.setFastSearchKey('MedicalType', 6);
      this.doctorSearch.setFastSearchKey('modeType', 100);
      this.doctorSearch.setFastSearchKey('WorkAsBarcode', 0);
      this.speciality = item ? item.code : null;
      this.specialityFromMatrix = this.speciality
      this.doctorSearch.clear();
      this.doctorSearch.clearItems();
    }
  }
  docIdSearchClicked(e: any) {
    this.showMonthlyMatirx = -1;
    this.monthlyOrDaily = 0;
    if (e && !e['AutoEmited'] && e['code']) {
      this.docId = e.code;
      this.doctorName = e.nameAr
      this.shortDoctorName = e.shortNameAr
      //  this.speciality = e.speciality;
      this.showPatient = true;
    }
    if (this.docId != undefined) {
      this.showPatient = true;
    } else {
      this.showPatient = false;
    }
  }

  docIdSearchFromMatrixClicked(e: any) {
    if (e && !e['AutoEmited'] && e['code']) {
      this.docIdFromMatrix = e.code;
      this.doctorName = e.nameAr
      this.shortDoctorName = e.shortDoctorName
    }
  }

  updatePatientReservationDoctorFromMonthlyMatrix() {
    console.log("rightClickedSlot From Doctor Reservation  = ", this.rightClickedSlot);
    this.matrixPatientParams.serial = this.rightClickedSlot.ccCallSerial;
    this.matrixPatientParams.docId = this.docIdFromMatrix;
    this.matrixPatientParams.specialization = this.specialityFromMatrix;
    this.matrixPatientParams.expectedStartTime = this.rightClickedSlot.startTimeSlot;
    this.matrixPatientParams.patCode = +this.rightClickedSlot.patCode;
    this._callCenterReservationService.updatePatientReservationDoctorFromMonthlyMatrix(this.matrixPatientParams)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        this.closeRightClickedSlot();
      },
        err => console.log(err),
        () => {
        });
  }

  //_______________________

  getModuleSettings() {
    this._callCenterReservationService.getStockModuleSettings({ moduleId: 5410 }) // Call Center Module
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        if (c.data && c.data.length > 0) {
          if (c.data[0]) {
            this.simpleReservationFromCallCenter = +c.data[0]['simpleReservationFromCallCenter']; // call center افتح بوب الحجز المبسط ولا لا
            this.prevDateReservationFromMonthlyMatrix = +c.data[0]['prevDateReservationFromMonthlyMatrix'];
            console.log("this.simpleReservationFromCallCenter = ", this.simpleReservationFromCallCenter);
            console.log("this.prevDateReservationFromMonthlyMatrix = ", this.prevDateReservationFromMonthlyMatrix);
          }
        }
      });






  }
  onpopupClose(parms: any) {
    if (parms && (parms.output == 'Cross click' || parms.output.returnFlag == true)) {
      this.showMonthlyMatirx = 1;
      this.monthlyDoctoroutPatient(this.monthNoClicked);
      this.dynamicComponent = null;

    }
  }

}